import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LeadContatoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}
	private httpOptionsNoAuth = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			// 'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}


	constructor(private http: HttpClient) { }

	public create(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}lead-contato/`, data, this.httpOptionsNoAuth)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getContatos(id_lead: number): Observable<any> {
		return this.http.get<any>(`${this.url}lead-contato/getIdCliente/${id_lead}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public findOne(id: number): Observable<any> {
		return this.http.get<any>(`${this.url}lead-contato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	
	public put(data: any, id: number, pIdLead: number, isDefault: boolean): Observable<any> {
		return this.http
			.put<any>(`${this.url}lead-contato/update/${id}`, {
				setor: data.value.setor,
				tipo: data.value.tipo,
				nome: data.value.nome,
				telefone: data.value.telefone,
				whatsapp: data.value.whatsapp,
				email: data.value.email,
				isDefault: isDefault,
				id_lead: pIdLead
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}
}
